import { createContext, useContext } from 'react';

import type { InviteEntryPoint } from './types';

/** One opening of the invite drawer: correlates its Segment events and tracks the form's dirty state. */
export type InviteSession = {
  flowId: string;
  entryPoint: InviteEntryPoint;
  fromUrl: string | null;
  /** Called by the invite form whenever its dirty state flips. */
  reportFormDirty: (isDirty: boolean) => void;
};

const InviteSessionContext = createContext<InviteSession | null>(null);

export const InviteSessionProvider = InviteSessionContext.Provider;

export const useInviteSession = () => useContext(InviteSessionContext);
